import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloat from "../WhatsAppFloat";
import MobileNav from "../MobileNav";
import AssistantChat from "../AssistantChat";
import AccessibilityWidget from "../AccessibilityWidget";
import api from "../../lib/api";
import { initAnalytics } from "../../lib/analytics";

export default function Layout() {
  useEffect(() => {
    api.get("/settings/public").then(({ data }) => {
      initAnalytics(data);
      document.documentElement.dataset.theme = data.theme || "klasik";
    }).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen flex flex-col pb-16 md:pb-0">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
      <AssistantChat />
      <AccessibilityWidget />
      <MobileNav />
    </div>
  );
}
